/**
 * Phase 4.22 — Client-side Versicherungs-Schätzung für Listing-Cards.
 *
 * Spiegelt 1:1 die Formel aus /app/backend/insurance_estimate.py um eine
 * deterministische Schätzung pro Karte zu liefern, ohne pro Card einen
 * Backend-Request abzusetzen. Default-SF1/2, Standard-Region.
 */
const SF_DEFAULT = 1.00;  // SF1/2
const CONDITION_FACTOR = {
    neu: 1.00, new: 1.00,
    gebraucht: 0.92, used: 0.92,
    demo: 0.95,
    abgemeldet: 0.80, project: 0.80, projekt: 0.80,
    defekt: 0.75, broken: 0.75,
};

function yearsOld(firstReg) {
    if (!firstReg) return 0;
    const d = new Date(firstReg);
    if (isNaN(d.getTime())) return 0;
    return Math.max(0, Math.floor((Date.now() - d.getTime()) / (365 * 24 * 3600 * 1000)));
}

export function estimateInsuranceLiability(listing, { sfFactor = SF_DEFAULT, regionFactor = 1.0 } = {}) {
    if (!listing) return null;
    const cat = listing.category || "motorcycle";
    const kw = Number(listing.power_kw || 0);
    if (cat !== "bicycle" && kw <= 0) return null;
    let base = cat === "bicycle" ? 80 : 250;
    if (kw > 35) base += 0.8 * (kw - 35);
    if (kw >= 50) base += 50;
    const yrs = yearsOld(listing.first_registration_date);
    const ageFactor = Math.max(0.7, 1 - 0.04 * yrs);
    const cond = (listing.condition || "gebraucht").toLowerCase();
    const condFactor = CONDITION_FACTOR[cond] ?? 0.92;
    const liability = base * ageFactor * condFactor * sfFactor * regionFactor;
    return Math.round(liability);
}

export function estimateInsuranceMonthly(listing, opts) {
    const yr = estimateInsuranceLiability(listing, opts);
    return yr == null ? null : Math.max(8, Math.round(yr / 12));
}
